import { AllRows, Columns, ReportData } from '../result.interface';

export function getFileExportParadasMovimientos(ctx: any, vrs: number): any {
    
        var exportFileEx = [];
        var bol_datos_ex = false;
        var column_config:Columns[] = [];
    
        var nom_inf = "REPORTE DE PARADAS Y MOVIMIENTOS";
        /* if (vm.optionUser() == 445 ) {
            var nom_inf = "REPORTE DE LUMINARIAS";
        } */
    
        var allRows: AllRows[] = [
            {
                cells: [
                { value: nom_inf, ...ctx.headerCellConfig, colSpan: 6 }
                ],
                height: ctx.headerRowsHeight,
            },
            ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
        ];
    
        var cc = 0;
    
        var chk_par:boolean;
        var chk_mov:boolean;
        var table_width;
    
        var estado_cell_ch_width = "Estado".length;
        var duracion_cell_ch_width = "Duracion".length;
        var posicion_detenida_cell_ch_width = "Ubicacion".length;//"Posicion Detenida".length;
        var recorrido_cell_ch_width = "Distancia Recorrida".length;//"Recorrido".length;
        var vel_max_cell_ch_width = "Velocidad Máxima GPS".length;//"Velocidad Maxima".length;
        var vel_max_can_cell_ch_width = "Velocidad Máxima CAN".length;//"Vel. max. CAN".length;
        var pc_cell_ch_width = "Punto cercano".length;
        var vel_promedio_cell_ch_width = "Velocidad Promedio".length;
        var vel_prom_can_cell_ch_width = "Vel. Prom. CAN".length;
        var referencia_cell_ch_width = "Referencia".length;
    
    
        var sortedData = ( ctx.exportOneTable ? ctx.sortedDataOneTabla : ctx.sortedData );
    
        console.log("****************+1");
        console.log(sortedData);
        console.log(ctx.sortedDataOneTabla );
        console.log(ctx.sortedData);
        console.log("****************+2");
    
    
    
        //ctx.sortedData.forEach((table_data: any) => {
        sortedData.forEach((table_data: any) => {
    
            if(table_data[1].length > 0){
            column_config = [];
    
            bol_datos_ex = true;
    
            let rowIndex = 0;
            var nom_vehi = table_data[0][1];
            var ruta = "";
            /* if (vm.optionR() == 28) {
                vm.period = data[3][10];
                ruta  = "RUTA : " + data[3][11];
    
                if (vrs == 1) {
                    cc = cc + 1;
                    nom_vehi = nom_vehi + " - " +cc;
                }
            } */
    
            table_width = 2 + (ctx.chkDateHour? 4:2) + 1 + (table_data[2].Paradas? 3:0) + (table_data[2].Movimientos? 5:0);
            var vehiculo_width = table_width<=8? 3:4;
            var ruta_width = table_width<=5? 1: table_width<=8? 3: 4;
            /* var vehiculo_width = table_width<=8? 2:3;
            var col_spacer = table_width<=5? 0: table_width<=8? 1: 2; */
    
            var rows: AllRows[] = [
                {
                cells: [
                    { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
                ],
                height: ctx.headerRowsHeight,
                },
                ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
                {
                cells: [
                    { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
                    //{ value: "RUTA",	...ctx.subHeaderRutaHeaderConfig, colSpan: ruta==""? 1: ruta_width },
                    //{ value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - (vehiculo_width +(ruta==""? 1:ruta_width)) },
                    { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
                ],
                height: ctx.subHeaderHeight
                },
                {
                cells: [
                    { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
                    //{ value: ruta	, ...ctx.subHeaderRutaContentConfig, colSpan: ruta==""? 1: ruta_width },
                    //{ value: ctx.period,  ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - (vehiculo_width +(ruta==""? 1:ruta_width)) },
                    { value: ctx.period,  ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
                ],
                height: ctx.subHeaderContentHeight
                },
                ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
            ];
    
            console.log("************** DD");
            console.log(table_data);
            console.log("************** DD");
    
            var cellsCampos = [];
    
            //----------- CABECERA ------------
            cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Estado", ...ctx.colHeaderConfig });
    
            if (ctx.chkDateHour) {
                cellsCampos.push({ value: "Fecha de Inicio", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Hora de Inicio", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Fecha de Fin", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Hora de Fin", ...ctx.colHeaderConfig });
            } else {
                cellsCampos.push({ value: "Inicio", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Fin", ...ctx.colHeaderConfig });
            }
    
            cellsCampos.push({ value: "Duración", ...ctx.colHeaderConfig });
    
            /* if (vm.optionUser() == 445 ) {  cellsCampos.push({ value: "H.Acumuladas", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 });  }; */
    
            if ( table_data[2].Paradas == true) 		{ cellsCampos.push({ value: "Ubicación", ...ctx.colHeaderConfig });  };
            if ( table_data[2].Movimientos == true) { cellsCampos.push({ value: "Distancia Recorrida", ...ctx.colHeaderConfig });					};
            if ( table_data[2].Movimientos == true) { cellsCampos.push({ value: "Velocidad Máxima GPS", ...ctx.colHeaderConfig });		};
            if ( table_data[2].Movimientos == true) { cellsCampos.push({ value: "Velocidad Máxima CAN", ...ctx.colHeaderConfig });		};
            if ( table_data[2].Paradas == true)			{ cellsCampos.push({ value: "Punto Cercano", ...ctx.colHeaderConfig }); 			};
            if ( table_data[2].Movimientos == true) { cellsCampos.push({ value: "Velocidad Promedio", ...ctx.colHeaderConfig });	};
            if ( table_data[2].Movimientos == true) { cellsCampos.push({ value: "Vel. Prom. CAN", ...ctx.colHeaderConfig });	};
            if ( table_data[2].Paradas == true)			{ cellsCampos.push({ value: "Referencia", ...ctx.colHeaderConfig }); 			};
    
            // <td ng-if="dato[2].ubicacion" ><a href="http://maps.google.com/maps?q={{dat.lat.toFixed(6)}},{{dat.lng.toFixed(6)}}&amp;t=m" target="_blank">{{dat.lat.toFixed(6)}},{{dat.lng.toFixed(6)}}</a></td>
    
            rows.push({
                cells: cellsCampos,
                height: ctx.colsHeaderHeight
            });
    
            console.log(table_data[2].Paradas+"   --- x --   "+table_data[2].Movimientos);
    
            if ( table_data[2].Paradas == true && table_data[2].Movimientos == true ) {
    
                table_data[1].forEach((item: { latitud: number; longitud: number; estado: any; fecha: any; fechasig: any; duracion: any; h_acumuladas: any; esInt: number; pCercano: any; referencia: any; recorrido: any; maxima_velocidad: any; vel_max_can: any; vel_promedio: any; vel_prom_can: any; }, index: number) => {
                    rowIndex++;
                    var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                    var cellsCuerpo = [];
    
                    estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.estado??'').toString().length);
                    duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
                    posicion_detenida_cell_ch_width = Math.max(posicion_detenida_cell_ch_width, (ubicacion??'').toString().length);
                    recorrido_cell_ch_width = Math.max(recorrido_cell_ch_width, (item.recorrido??'').toString().length);
                    vel_max_cell_ch_width = Math.max(vel_max_cell_ch_width, (item.maxima_velocidad??'').toString().length);
                    vel_max_can_cell_ch_width = Math.max(vel_max_can_cell_ch_width, (item.vel_max_can??'').toString().length);
                    pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.pCercano??'').toString().length);
                    vel_promedio_cell_ch_width = Math.max(vel_promedio_cell_ch_width, (item.vel_promedio??'').toString().length);
                    vel_prom_can_cell_ch_width = Math.max(vel_prom_can_cell_ch_width, (item.vel_prom_can??'').toString().length);
                    referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
    
                    cellsCuerpo.push({ value: rowIndex, ...ctx.bodyRowsConfig });
                    cellsCuerpo.push({ value: item.estado, ...ctx.bodyRowsConfig });
    
                    if (ctx.chkDateHour) {
                        // var fh = item.fecha.split(" ");
                        // var fh2 = item.fechasig.split(" ");
    
                        cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: ctx.isChe(item.fechasig), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: ctx.isChs(item.fechasig), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
    
                    } else {
                        cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: ctx.isChe(item.fechasig), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                    }
    
                    cellsCuerpo.push({ value: item.duracion, ...ctx.bodyRowsConfig });
                    /* if (vm.optionUser() == 445 ) {  cellsCuerpo.push({ value: item.h_acumuladas, ...ctx.bodyRowsConfig });  }; */
    
                    if (item.esInt == 0) {
                        // cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });
    
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.pCercano, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.referencia, ...ctx.bodyRowsConfig });
                    }
    
                    if (item.esInt == 1) {
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.recorrido, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.maxima_velocidad, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.vel_max_can, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.vel_promedio, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.vel_prom_can, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: "---", ...ctx.bodyRowsConfig });
                    }
    
                    rows.push({
                        cells: cellsCuerpo,
                        height: ctx.bodyRowsHeight
                    });
                });
            }
    
            if ( table_data[2].Paradas == true && table_data[2].Movimientos == false ) {
    
                table_data[1].forEach((item: { esInt: number; latitud: number; longitud: number; estado: any; fecha: any; fechasig: any; duracion: any; h_acumuladas: any; pCercano: any; referencia: any; }, index: number) => {
                    if (item.esInt==0) {
                        rowIndex++
                        var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                        var cellsCuerpo = [];
    
    
                        estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.estado??'').toString().length);
                        duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
                        posicion_detenida_cell_ch_width = Math.max(posicion_detenida_cell_ch_width, (ubicacion??'').toString().length);
                        pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.pCercano??'').toString().length);
                        referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
    
                        cellsCuerpo.push({ value: rowIndex, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.estado, ...ctx.bodyRowsConfig });
    
                        if (ctx.chkDateHour) {
                            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChe(item.fechasig), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChs(item.fechasig), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
    
                        } else {
                            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChe(item.fechasig), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                        }
    
                        cellsCuerpo.push({ value: item.duracion, ...ctx.bodyRowsConfig });
                        /* if (vm.optionUser() == 445 ) {  cellsCuerpo.push({ value: item.h_acumuladas, ...ctx.bodyRowsConfig });  }; */
    
                        // cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });
                        // cellsCuerpo.push({ value: "--", ...ctx.bodyRowsConfig });
                        // cellsCuerpo.push({ value: "--", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.pCercano, ...ctx.bodyRowsConfig });
                        // cellsCuerpo.push({ value: "--", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.referencia, ...ctx.bodyRowsConfig });
    
                        rows.push({
                            cells: cellsCuerpo,
                            height: ctx.bodyRowsHeight
                        });
                    }
    
                });
            }
    
    
            if (  table_data[2].Paradas == false && table_data[2].Movimientos == true ) {
    
                table_data[1].forEach((item: { esInt: number; latitud: number; longitud: number; estado: any; fecha: any; fechasig: any; duracion: any; h_acumuladas: any; recorrido: any; maxima_velocidad: any; vel_max_can: any; vel_promedio: any; vel_prom_can: any; }, index: number) => {
                    if (item.esInt == 1) {
                        rowIndex++;
                        var cellsCuerpo = [];
    
                        estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.estado??'').toString().length);
                        duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
                        recorrido_cell_ch_width = Math.max(recorrido_cell_ch_width, (item.recorrido??'').toString().length);
                        vel_max_cell_ch_width = Math.max(vel_max_cell_ch_width, (item.maxima_velocidad??'').toString().length);
                        vel_max_can_cell_ch_width = Math.max(vel_max_can_cell_ch_width, (item.vel_max_can??'').toString().length);
                        vel_promedio_cell_ch_width = Math.max(vel_promedio_cell_ch_width, (item.vel_promedio??'').toString().length);
                        vel_prom_can_cell_ch_width = Math.max(vel_prom_can_cell_ch_width, (item.vel_prom_can??'').toString().length);
    
                        cellsCuerpo.push({ value: rowIndex, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.estado, ...ctx.bodyRowsConfig });
    
                        if (ctx.chkDateHour) {
                            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChe(item.fechasig), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChs(item.fechasig), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                        } else {
                            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                            cellsCuerpo.push({ value: ctx.isChe(item.fechasig), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                        }
    
                        cellsCuerpo.push({ value: item.duracion, ...ctx.bodyRowsConfig });
                        /* if (vm.optionUser() == 445 ) {  cellsCuerpo.push({ value: item.h_acumuladas, ...ctx.bodyRowsConfig });  }; */
    
                        // cellsCuerpo.push({ value: "--", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.recorrido, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.maxima_velocidad, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.vel_max_can, ...ctx.bodyRowsConfig });
                        // cellsCuerpo.push({ value: "--", ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.vel_promedio, ...ctx.bodyRowsConfig });
                        cellsCuerpo.push({ value: item.vel_prom_can, ...ctx.bodyRowsConfig });
                        // cellsCuerpo.push({ value: "--", ...ctx.bodyRowsConfig });
    
                        rows.push({
                            cells: cellsCuerpo,
                            height: ctx.bodyRowsHeight
                        });
                    }
    
                });
            }
    
            // //************************** RESUMEN*******************
    
            if (!ctx.exportOneTable) {
                rows.push(
                    ...ctx.spaceBetweenTables,
                    {
                        cells: [
                        { value: "Longitud de Ruta : ", ...ctx.overviewLeftConfig },
                        { value: table_data[3][0], ...ctx.overviewRightConfig }
                        ],
                        height: ctx.overviewRowsHeight
                    },
                    {
                        cells: [
                        { value: "Duración de Movimiento : ", ...ctx.overviewLeftConfig },
                        { value: table_data[3][1], ...ctx.overviewRightConfig }
                        ],
                        height: ctx.overviewRowsHeight
                    },
                    {
                        cells: [
                        { value: "Duración Detenido : ", ...ctx.overviewLeftConfig },
                        { value: table_data[3][2], ...ctx.overviewRightConfig }
                        ],
                        height: ctx.overviewRowsHeight
                    },
                    {
                        cells: [
                        { value: "Velocidad más Alta : ", ...ctx.overviewLeftConfig },
                        { value: table_data[3][3], ...ctx.overviewRightConfig }
                        ],
                        height: ctx.overviewRowsHeight
                    },
                    {
                        cells: [
                        { value: "Velocidad Promedio : ", ...ctx.overviewLeftConfig },
                        { value: table_data[3][4], ...ctx.overviewRightConfig }
                        ],
                        height: ctx.overviewRowsHeight
                    }
                );
            }
    
    
            /* if (vm.optionUser() == 445 ) {
                rows.push(
                {
                    cells: [
                    { value: "HORAS TRABAJADAS EN EL PERIODO: ", vAlign: "center", hAlign: "center", fontSize: ctx.r1, colSpan: 3 },
                    { value: data[3][5], vAlign: "center", hAlign: "center", fontSize: ctx.r1 }
                    ]
                },
                {
                    cells: [
                    { value: "TOTAL DE HORAS TRABAJADAS : ", vAlign: "center", hAlign: "center", fontSize: ctx.r1, colSpan: 3 },
                    { value: data[3][6], vAlign: "center", hAlign: "center", fontSize: ctx.r1 }
                    ]
                }
                )
            };
            */
    
            // //********************************************* excel version 2 *********************************
            if ( vrs == 2 ) {
                if( chk_par === undefined || chk_mov === undefined ) {
                chk_par = table_data[2].Paradas;
                chk_mov = table_data[2].Movimientos;
                }
                rows.splice(0, ctx.headerRowSpan);
                rows.push(...ctx.spaceBetweenTables);
                allRows = allRows.concat(rows);
            }
            // //********************************************* excel version 2 *********************************
    
            // //********************************************* excel version 1 *********************************
    
            /* Ancho de Columnas */
    
            if( vrs == 1 ){
                column_config = [
                { width: ctx.w_item },
                { width: ctx.calculateColWidth(estado_cell_ch_width) },
                ];
                if(ctx.chkDateHour){
                column_config.push(
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                )
                } else {
                column_config.push(
                    { width: ctx.w_date_and_hour },
                    { width: ctx.w_date_and_hour },
                )
                }
                column_config.push({ width: ctx.calculateColWidth(duracion_cell_ch_width) });
                if( table_data[2].Paradas && table_data[2].Movimientos ){
                column_config.push(
                    { width: ctx.calculateColWidth(posicion_detenida_cell_ch_width) },
                    { width: ctx.calculateColWidth(recorrido_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_max_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_max_can_cell_ch_width) },
                    { width: ctx.calculateColWidth(pc_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_promedio_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_prom_can_cell_ch_width) },
                    { width: ctx.calculateColWidth(referencia_cell_ch_width) },
                )
                }
                if( !table_data[2].Paradas && table_data[2].Movimientos ){
                column_config.push(
                    { width: ctx.calculateColWidth(recorrido_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_max_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_max_can_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_promedio_cell_ch_width) },
                    { width: ctx.calculateColWidth(vel_prom_can_cell_ch_width) },
                )
                }
                if( table_data[2].Paradas && !table_data[2].Movimientos ){
                column_config.push(
                    { width: ctx.calculateColWidth(posicion_detenida_cell_ch_width) },
                    { width: ctx.calculateColWidth(pc_cell_ch_width) },
                    { width: ctx.calculateColWidth(referencia_cell_ch_width) },
                )
                }
    
                /* Fin Ancho de Columnas */
    
                exportFileEx.push({
                freezePane: {
                    rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
                    },
                columns: column_config,
                title: nom_vehi,
                rows: rows
                });
    
                estado_cell_ch_width = "Estado".length;
                duracion_cell_ch_width = "Duracion".length;
                posicion_detenida_cell_ch_width = "Posicion Detenida".length;
                recorrido_cell_ch_width = "Recorrido".length;
                vel_max_cell_ch_width = "Velocidad Maxima".length;
                pc_cell_ch_width = "Punto cercano".length;
                vel_promedio_cell_ch_width = "Velocidad Promedio".length;
                referencia_cell_ch_width = "Referencia".length;
            }
    
            // //********************************************* excel version 1 *********************************
    
    
    
            } // if si hay datos del vehiculo
        });
    
        //********************************************* excel version 2 *********************************
        if (vrs == 2) {
            allRows[0].cells![0].colSpan = table_width;
    
            column_config = [
            { width: ctx.w_item },
            { width: ctx.calculateColWidth(estado_cell_ch_width) },
            ];
            if(ctx.chkDateHour){
            column_config.push(
                { width: ctx.w_date_ini_fin },
                { width: ctx.w_hour_ini_fin },
                { width: ctx.w_date_ini_fin },
                { width: ctx.w_hour_ini_fin },
            )
            } else {
            column_config.push(
                { width: ctx.w_date_and_hour },
                { width: ctx.w_date_and_hour },
            )
            }
            column_config.push({ width: ctx.w_duracion});
            if( chk_par! && chk_mov! ){
            column_config.push(
                { width: ctx.calculateColWidth(posicion_detenida_cell_ch_width) },
                { width: ctx.calculateColWidth(recorrido_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_max_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_max_can_cell_ch_width) },
                { width: ctx.calculateColWidth(pc_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_promedio_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_prom_can_cell_ch_width) },
                { width: ctx.calculateColWidth(referencia_cell_ch_width) },
            )
            }
            if( !chk_par! && chk_mov! ){
            column_config.push(
                { width: ctx.calculateColWidth(recorrido_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_max_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_max_can_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_promedio_cell_ch_width) },
                { width: ctx.calculateColWidth(vel_prom_can_cell_ch_width) },
            )
            }
            if( chk_par! && !chk_mov! ){
            column_config.push(
                { width: ctx.calculateColWidth(posicion_detenida_cell_ch_width) },
                { width: ctx.calculateColWidth(pc_cell_ch_width) },
                { width: ctx.calculateColWidth(referencia_cell_ch_width) },
            )
            }
    
            exportFileEx.push({
            freezePane: {
                rowSplit: ctx.headerRowSpan
                },
            columns: column_config,
            title: "Resultado",//data[0][1],
            rows: allRows
            });
            /* exportFileEx.push({
                freezePane: {
                    rowSplit: ctx.headerRowSpan
                },
                columns: [
                { width: 50 },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },
                { autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },
                { autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },
                { autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },
                { autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true },{ autoWidth: true }
                ],
                title: "Resultado",//data[0][1],
                rows: allRows
            }); */
        }

    
        console.log("===>exportFileEx getFileExportParadasMovimientos", exportFileEx);  
        if (bol_datos_ex) {
            return exportFileEx;
        } else {
            return [];
        }

}


